import { axios } from "../utils/request";
import axiosQiniu from "axios";

export function getQiniuToken() {
    return axios.get("/qiniu");
}

export function uploadQiniu(formData) {
    return axiosQiniu({
        url: "https://upload.qiniup.com",
        method: "post",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
    });
}
